import { https , httpsFile } from './http.js' ;

export async function datatable(data){
    return https().post('material-master',data);
}
export async function newMaterialSearch(data){
    return https().post('material-master-new',data);
}

export function index(){
    return https().get('items');
}

export function show(value,company_code){
    return https().get(`/items/${value}?company_code=${company_code}`);
}

export function materialGroup(){
    return https().get('material-group');
}

export function offtake(matnr){
    return https().get(`/offtake/${matnr}`)
}

export function lastmonth(matnr){
    return https().get(`/lastmonth/${matnr}`)
}

export function inventory(matnr){
    return https().get(`/inventory/${matnr}`)
}

export function onorder(matnr){
    return https().get(`/onorder/${matnr}`)
}

export function update (id,data) {
    return https().post(`/items/${id}`,data);
}

export function create(data,company){
    return https().get(`/items/create?matnr_id=${data}&company_code=${company}`);
}

export function reduction(id,data){
    return httpsFile().post(`item-reductions/${id}`,data);
}

export function materialgroup(){
    return httpsFile().get(`/material-group`);
}

export function materialmaster(currentpage,page,search,material_type,data,search_from = null){
    return https().post(`/materialmaster?search=${search}&page=${page}&currentpage=${currentpage}&material_type=${material_type}&search_from=${search_from}`,data);
}

export function stocksTransfer(data) {
    return https().get(`/stocks-quantity?${data}`);
}

export function checkBudget(data){
    return https().get(`/checkBudget?${data}`);
}
export function searchMaterial(material,offset){
    return https().get(`/searchMaterialItem?search=${material}&offset=${offset}`);
}
export function showRecommended(supplier,matkl,page){
    return https().get(`/showRecommended?supplier=${supplier}&matkl=${matkl}&page=${page}`);
}

export function exportMaterials(data) {
    return https().post(`exportMaterials`,data);
}